import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import PortImage8 from '../../images/portfolio/image_8.jpg';
import PortImage9 from '../../images/portfolio/image_9.jpg';
import PortImage10 from '../../images/portfolio/image_10.jpg';
import PortImage11 from '../../images/portfolio/image_11.jpg';
import PortImage12 from '../../images/portfolio/image_12.jpg';

class Index extends Component {
	
	render(){
		return (
			<>
				<Header1 />
				
				{/* <!-- Content --> */}
				<div className="page-content bg-white">
					
					<div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">name of the industrie</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
										<li>Industries</li>
									</ul>
								</div>
							 </div>
						</div>
					</div>
					
					<div className="content-block" id="content-area">
						
						<div className="section-area section-sp2 port-7-content">
							<div className="container">
								<div className="row">
									<div className="col-lg-7">
										<div className="heading-bx text-left m-b20">
											<h3 className="title-head m-b0">title of the industrie</h3>
											<div className="ttr-separator sepimg"></div>
										</div>
										<p>Well we’re movin’ on up to the east side. To a deluxe apartment in the sky. The weather started getting rough – the tiny ship was tossed. If not for the courage of the fearless crew the Minnow would be lost. the Minnow would be lost. We’re gonna do it. On your mark get set and go now. Got a dream and we just know now we’re gonna make our dream come true. I have always wanted to have a neighbor just like you. I’ve always wanted to live in a neighborhood with you.</p>
										
									</div>
									<div className="col-lg-5">
										<div className="row sp4 magnific-image sticky-top">
											<div className="action-card col-lg-12 col-md-12 col-sm-12 col-12 wow fadeInUp" data-wow-delay="0.6s">
												<div className="portfolio-box style-2">
													<div className="portfolio-media">
														<img src={PortImage10} alt=""/>
													</div>
													<Link to="projects-single-1" className="magnific-anchor">View Details</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
					
				</div>
				
				<Footer1 />
				
			</>
		);
	}
}

export default Index;